import React, { useEffect, useRef } from 'react';
import { motion, useInView, animate } from 'framer-motion';
interface CounterProps {
  from: number;
  to: number;
  duration: number;
  prefix?: string;
  suffix?: string;
}
function Counter({
  from,
  to,
  duration,
  prefix = '',
  suffix = ''
}: CounterProps) {
  const nodeRef = useRef<HTMLSpanElement>(null);
  const inView = useInView(nodeRef, {
    once: true,
    margin: '-100px'
  });
  useEffect(() => {
    if (inView) {
      const controls = animate(from, to, {
        duration,
        ease: 'easeOut',
        onUpdate(value) {
          if (nodeRef.current) {
            nodeRef.current.textContent = `${prefix}${Math.round(value)}${suffix}`;
          }
        }
      });
      return () => controls.stop();
    }
  }, [from, to, duration, prefix, suffix, inView]);
  return <span ref={nodeRef} data-id="element-319" data-mp="1qabb4j32vnbg">
      {prefix}
      {from}
      {suffix}
    </span>;
}
export function Stats() {
  return <section className="py-20 md:py-28 relative bg-white border-y border-slate-200" data-id="element-320" data-mp="1v7uwe2y710cw">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12" data-id="element-321" data-mp="54ga5v8mw2og">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-0" data-id="element-322" data-mp="76dpvmtuqr4">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-center" data-id="element-323" data-mp="9143pgvbb2l">
            <div className="text-6xl md:text-7xl font-light text-slate-900 mb-4 tracking-tight" data-id="element-324" data-mp="3dne29sirfc67">
              <Counter from={0} to={85} duration={2} suffix="%" data-id="element-325" data-mp="3re96usm8773z" />
            </div>
            <p className="text-sm text-slate-600 font-medium uppercase tracking-wider mb-1" data-id="element-326" data-mp="3mkoh1nusdjfv">
              Less CRM busywork
            </p>
            <span className="block text-xs text-slate-500 font-normal normal-case tracking-normal" data-id="element-327" data-mp="2uv1u2p5fdgo5">
              vs. manual note-taking
            </span>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.08
        }} className="text-center md:border-x md:border-slate-200" data-id="element-328" data-mp="xscu7i3iqtot">
            <div className="text-6xl md:text-7xl font-light text-slate-900 mb-4 tracking-tight" data-id="element-329" data-mp="ju4nwjkleg0z">
              <Counter from={0} to={3} duration={1.5} suffix="x" data-id="element-330" data-mp="ot7vobryj0cn" />
            </div>
            <p className="text-sm text-slate-600 font-medium uppercase tracking-wider mb-1" data-id="element-331" data-mp="tsu9ambp6ilz">
              More complete deal records
            </p>
            <span className="block text-xs text-slate-500 font-normal normal-case tracking-normal" data-id="element-332" data-mp="2084m9q3shxm4">
              compared to manual entry
            </span>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.16
        }} className="text-center" data-id="element-333" data-mp="3pqbcjqta3v7l">
            <div className="text-6xl md:text-7xl font-light text-slate-900 mb-4 tracking-tight" data-id="element-334" data-mp="3633rja5mrrkj">
              <Counter from={0} to={2} duration={1.5} prefix="<" suffix=" min" data-id="element-335" data-mp="31ze6guo5zs49" />
            </div>
            <p className="text-sm text-slate-600 font-medium uppercase tracking-wider mb-1" data-id="element-336" data-mp="2s32q9tlgei4j">
              Call to HubSpot sync
            </p>
            <span className="block text-xs text-slate-500 font-normal normal-case tracking-normal" data-id="element-337" data-mp="v7wx5dykcfyc">
              from call end to synced data
            </span>
          </motion.div>
        </div>
      </div>
    </section>;
}